import { Asset, AssetList } from "../types/Assets"

/**
 * Get an array of asset objects
 * 
 * @param assetList -> List of assets in colocated format
 */
export const getListOfAssets = (assetList: AssetList) : Asset[] => (Object.values(assetList).map(({ assets }) => [...assets]).flat())
